export default __webpack_public_path__ + "static/media/img-0173-spain-full-face.6ad84dae.png";